skyward.base.registerScript("fieldRestriction", function ()
{
    "use strict";

    /**
     * @global
     * @typedef {Object} FieldRestrictionHandler Handles the hiding required when a field restriction is encountered
     * @property {function():boolean} isApplicable With a given marker, returns if this FieldRestrictionHandler is appropriate to use
     * @property {function():undefined} hideControlOnly Hide the control related to the marker
     * @property {function():undefined} hideControlAndLabel Hide the control and label related to the marker
     */

    /**
     * Process the Field Restriction noted by a marker
     */
    function processRestriction()
    {
        var marker = $(this);
        var data = marker.data();

        if (data.renderControl && data.renderLabel)
        {
            return;
        }

        var fieldRestrictionHandler = getFieldRestrictionHandler(marker);

        if (!data.renderControl && !data.renderLabel)
        {
            fieldRestrictionHandler.hideControlAndLabel();
        }
        else if (!data.renderControl)
        {
            fieldRestrictionHandler.hideControlOnly();
        }
    }

    /**
     * Get the FieldRestrictionHandler that is most applicable for the given marker
     * @param {JQuery} marker The marker that signifies a Field Restriction was encountered
     * @return {FieldRestrictionHandler} The most applicable FieldRestrictionHandler for the given marker
     */
    function getFieldRestrictionHandler(marker)
    {
        // Listed in the order they should be checked
        var fieldRestrictionHandlers =
        [
            {
                // Browse/ReferenceView Handler
                isApplicable: function () { return marker.parent().hasClass("browse") || marker.prev().hasClass("refArea"); },
                hideControlOnly: function () { /* Do Nothing */ },
                hideControlAndLabel: function () { /* Do Nothing */ }
            },
            {
                // Code EEL Selector Handler
                isApplicable: function () { return marker.prev().hasClass("eELInputContainer"); },
                hideControlOnly: function () { hide(marker.prev()); },
                hideControlAndLabel: function () { hide(marker.prev()); }
            },
            {
                // Checkbox Group Handler
                isApplicable: function () { return marker.closest(".js-checkboxGroup__row").length !== 0; },
                hideControlOnly: function () { hide(marker.prev()); },
                hideControlAndLabel: function ()
                {
                    var row = marker.closest(".js-checkboxGroup__row");
                    skyward.controls.hide(row, false);
                }
            },
            {
                // General Control Handler
                isApplicable: function () { return marker.closest("fieldset").length !== 0; },
                hideControlOnly: function () { hide(marker.prev()); },
                hideControlAndLabel: function () { hide(marker.closest("fieldset")); }
            },
            {
                // Default
                // Do not remove - the last entry must handle all remaining controls
                isApplicable: function () { return true; },
                hideControlOnly: function () { hide(marker.prev()); },
                hideControlAndLabel: function () { hide(marker.closest("fieldset")); }
            }
        ];

        return getApplicableHandler(fieldRestrictionHandlers);

        function hide(target)
        {
            // only show the marker (***) if the target is a form element
            if (target.is(":input") || target.has(":input").length > 0)
            {
                marker.show();
            }
            target.hide();
            target.trigger("visible", false); // needed to update select-all checkboxes
        }

        function getApplicableHandler(handlers)
        {
            var handler = handlers.find(function (handler)
            {
                return handler.isApplicable();
            });
            return handler !== undefined ? handler : fieldRestrictionHandlers[fieldRestrictionHandlers.length - 1];
        }
    }

    function handleTypeCode(context)
    {
        var doNotPostClass = "doNotPost";
        var fieldSelectorValue = context.find(".js-fieldSelector__hidden[name='FieldRestriction.FieldID']");
        var codeEelValue = context.find(".codeEELValue[name='FieldRestriction.FieldID']");
        var restrictionTypeCodeControl = context.find("[name='FieldRestriction.RestrictionTypeCode']");

        togglePostedFieldIDField.apply(restrictionTypeCodeControl);
        restrictionTypeCodeControl.on("change", togglePostedFieldIDField);

        // Both field controls (field selector and code eel) both point to the same field, so when the user
        // hits back, they both get populated with the same value when the task loads. If the user clicks back 
        // and they did not have Denied selected for restriction type, we clear out the value since it is
        // likely not a valid denied field.
        if (codeEelValue.hasClass(doNotPostClass))
        {
            skyward.codeeel.clear(codeEelValue.closest(".codeEEL"));
        }

        function togglePostedFieldIDField()
        {
            var isDeniedValue = $(this).val() === "D";
            fieldSelectorValue.toggleClass(doNotPostClass, isDeniedValue);
            codeEelValue.toggleClass(doNotPostClass, !isDeniedValue);
        }
    }

    var events =
    {
        handleTypeCode: handleTypeCode,
        processRestriction: processRestriction
    };

    return events;
});